import { Text, View } from "@react-pdf/renderer";

import TextWrapper from "./text-wrapper.component";

type PdfDocumentLabelValueProps = {
  label?: string;
  labelWidth?: string;
  valueMaxWidth?: string;
  value: any;
  noBorder?: boolean;
  style?: any;
};
export default function PdfDocumentLabelValue({
  label,
  labelWidth = "65px",
  valueMaxWidth = "280px",
  value,
  noBorder,
  style = {}
}: PdfDocumentLabelValueProps) {
  return (
    <View
      style={{
        borderBottom: noBorder ? undefined : "1px solid #381337",
        paddingTop: "4px",
        paddingBottom: "4px",
        color: "#000000",
        ...style
      }}
    >
      <View
        style={{
          display: "flex",
          flexDirection: "row",
          gap: "8px",
          minHeight: "16px",
          color: "#000000"
        }}
      >
        {Boolean(label) && (
          <View
            style={{
              width: labelWidth,
              paddingTop: "2px",
              color: "#000000"
            }}
          >
            <Text style={{ fontSize: "11px", color: "#000000" }}>{label}</Text>
          </View>
        )}

        <View style={{ maxWidth: valueMaxWidth }}>
          {typeof value === "string" || !Boolean(value) ? (
            <TextWrapper
              text={String(value ?? "")}
              style={{ fontSize: "14px", color: "#000000" }}
            />
          ) : (
            value
          )}
        </View>
      </View>
    </View>
  );
}
